/**
 * Country picker (full-screen overlay) tokens. Exact values ported from the
 * standalone app's `features/country/CountrySelector.tsx`.
 *
 * Wrapped through the theming registry (`themed()`) so each colour resolves to a
 * `var(--ows-cfg-country-…)` custom property; the captured literals are the dark
 * theme, light values are authored in `themePalette.ts`. Registered at boot via
 * `registerThemeTokens.ts`.
 */
import { themed } from '../../../theme/themeRegistry';

export const COUNTRY = themed('cfgCountry', {
  // Dimmed, blurred backdrop behind the panel.
  backdrop:
    'linear-gradient(90deg, rgba(0, 0, 0, 0.48) 0%, rgba(0, 0, 0, 0.48) 100%), linear-gradient(90deg, rgba(3, 3, 6, 0.82) 0%, rgba(3, 3, 6, 0.82) 100%)',
  panelBg: '#0a0a0b',
  panelBorder: 'rgba(255, 255, 255, 0.24)',
  hairline: 'rgba(255, 255, 255, 0.1)',
  // Washed zinc hero card holding the title + search.
  heroBg:
    'linear-gradient(90deg, rgba(3, 3, 6, 0.28) 0%, rgba(3, 3, 6, 0.28) 100%), linear-gradient(90deg, #17181c 0%, #17181c 100%)',
  closeBg: 'rgba(255, 255, 255, 0.1)',
  closeHover: 'rgba(255, 255, 255, 0.2)',
  rowHover: 'rgba(255, 255, 255, 0.05)',
  // Country grid responsive steps (original Tailwind sm / lg → 3 / 4 columns).
  gridSm: '@media (min-width: 640px)',
  gridLg: '@media (min-width: 1024px)',
} as const);
